import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-sdg-certificate',
  templateUrl: './sdg-certificate.component.html',
  styleUrls: ['./sdg-certificate.component.scss'],
})
export class SDGCertificateComponent implements OnInit {
  @Input() label: string;
  @Input() level = 0;
  @Input() total = [];
  @Input() value: number;
  constructor() {}

  get totalRange() {
    console.log((this.total))
    return [...Array(this.total.length - 1).keys()];
  }

  ngOnInit(): void {}
}
